import { createFeatureSelector, createSelector } from '@ngrx/store';

import { TechnicalResultState } from '../../models/technical-result.model';

export const getTechnicalResultState =
  createFeatureSelector<TechnicalResultState>('technical-result');

export const getTechnicalResultStateByDate = createSelector(
  getTechnicalResultState,
  (state: TechnicalResultState) => state.technicalResult,
);
